import React, { createContext, useContext, useEffect, useState } from "react";
import { effectivePrice } from "@/lib/pricing";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("sd_cart") || "[]"); }
    catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem("sd_cart", JSON.stringify(items));
  }, [items]);

  const addItem = (product, quantity = 1) => {
    setItems((prev) => {
      const found = prev.find((i) => i.product.id === product.id);
      if (found) {
        return prev.map((i) => i.product.id === product.id
          ? { ...i, quantity: i.quantity + quantity } : i);
      }
      return [...prev, { product, quantity }];
    });
  };

  const setQty = (id, quantity) => {
    if (quantity <= 0) return removeItem(id);
    setItems((prev) => prev.map((i) => i.product.id === id ? { ...i, quantity } : i));
  };

  const removeItem = (id) => setItems((prev) => prev.filter((i) => i.product.id !== id));
  const clear = () => setItems([]);

  const unitPrice = (i) => effectivePrice(i.product, i.quantity);
  const lineTotal = (i) => unitPrice(i) * i.quantity;

  const count = items.reduce((s, i) => s + i.quantity, 0);
  const subtotal = items.reduce((s, i) => s + lineTotal(i), 0);

  return (
    <CartContext.Provider value={{ items, addItem, setQty, removeItem, clear, count, subtotal, unitPrice, lineTotal }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
